module.exports = __webpack_public_path__ + "img/product_symbol.52f2fe54.svg";